import { log } from "../log.ts";

import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "sonner";

import { TooltipProvider } from "@bigpp/ui/components/tooltip";

import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";

import { officeReady } from "../office-ready.ts";
import "../styles.css";
import { queryClient, trpc, trpcClient } from "../trpc.ts";

import { TaskPane } from "./TaskPane.tsx";

const mount = () => {
  const container = document.getElementById("root");
  if (!container) throw new Error("Missing #root");
  createRoot(container).render(
    <StrictMode>
      <trpc.Provider client={trpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <TooltipProvider delayDuration={200} skipDelayDuration={100}>
            <TaskPane />
            <Toaster
              position="top-center"
              richColors
              closeButton
              toastOptions={{ className: "text-xs" }}
            />
          </TooltipProvider>
        </QueryClientProvider>
      </trpc.Provider>
    </StrictMode>,
  );
};

void officeReady.then((host) => {
  log.info("addin.boot", {
    host: host ?? null,
    platform: typeof Office !== "undefined" ? (Office.context?.platform ?? null) : null,
    officeVersion:
      typeof Office !== "undefined"
        ? (Office.context?.diagnostics?.version ?? null)
        : null,
  });
  mount();
});
